import type {IOrderRepository, OrderFilters} from '../../../domain/repositories/IOrderRepository';
import {Order, OrderStatus} from '../../../domain/entities/Order';

export class GetOrdersUseCase {
    constructor(private readonly orderRepository: IOrderRepository) {
    }

    async getById(id: string): Promise<Order> {
        const order = await this.orderRepository.findById(id);
        if (!order) {
            throw new Error('Order not found');
        }
        return order;
    }

    async getByOrderNo(orderNo: number): Promise<Order> {
        const order = await this.orderRepository.findByOrderNo(orderNo);
        if (!order) {
            throw new Error('Order not found');
        }
        return order;
    }

    async getByUserId(userId: string, filters?: OrderFilters): Promise<Order[]> {
        return this.orderRepository.findByUserId(userId, filters);
    }

    async getAll(filters?: OrderFilters): Promise<Order[]> {
        return (await this.orderRepository.findAll(filters)).results;
    }

    async getUserOrderHistory(userId: string, limit: number = 10): Promise<Order[]> {
        return this.orderRepository.findByUserId(userId, {
            limit,
            sortBy: 'created',
            sortOrder: 'desc'
        });
    }

    async getPendingOrders(userId?: string): Promise<Order[]> {
        const filters: OrderFilters = {
            status: [OrderStatus.PENDING, OrderStatus.CONFIRMED],
            sortBy: 'created',
            sortOrder: 'desc'
        };

        if (userId) {
            return this.orderRepository.findByUserId(userId, filters);
        }

        return (await this.orderRepository.findAll(filters)).results;
    }

    async getOrdersRequiringPayment(userId: string): Promise<Order[]> {
        const orders = await this.orderRepository.findByUserId(userId, {
            status: [OrderStatus.PENDING, OrderStatus.CONFIRMED]
        });

        return orders
        // .filter(order => {
        //     const nextPayment = order.getNextPaymentDue();
        //     return nextPayment !== null;
        // });
    }

    async getOverdueOrders(userId?: string): Promise<Order[]> {
        const filters: OrderFilters = {
            status: [OrderStatus.CONFIRMED, OrderStatus.PROCESSING],
            sortBy: 'created',
            sortOrder: 'asc'
        };

        let orders: Order[];
        if (userId) {
            orders = await this.orderRepository.findByUserId(userId, filters);
        } else {
            orders = (await this.orderRepository.findAll(filters)).results;
        }

        return orders//.filter(order => order.isOverdue());
    }
}